var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"btn btn-icon",on:{"click":function($event){return _vm.$emit('click', $event)}}},[_c('i',{staticClass:"fas fa-chevron-left"})])}
var staticRenderFns = []

export { render, staticRenderFns }